import vueCmsSvc from '@services/vueCmsSvc';

const state = {
  cmsSettings: {},
  // CMS Partials Map, to avoid loading the same partials multiple times
  cmsPartials: {},
};

const getters = {
  componentSettings: (state) => (key) => {
    return state.cmsSettings[key];
  },

  getPartial: (state) => (key) => {
    return state.cmsPartials[key];
  }
};

const actions = {
  loadPartial({ commit }, params) {
    const { mixinKey } = params;

    // Check if the partial is already loaded
    if (state.cmsPartials[mixinKey]) {
      return Promise.resolve();
    }

    return vueCmsSvc.getPartial({ mixinKey }).then(response => {
      const { data } = response;
      if (data && data.html && data.css) {
        commit('setCmsPartial', { key: mixinKey, val: data });
      }
    });

  }
};

const mutations = {
  setCmsSettings(state, val = {}) {
    state.cmsSettings = val;
  },

  setCmsPartial(state, { key, val }) {
    state.cmsPartials = {
      ...state.cmsPartials,
      [key]: val,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
